@let singleValue = singleValue$ | async;
@if (singleValue) {
    <div class="single-value text">
        <div [class.value-wraper]="!!(caption$ | async)" [class.single-value]="!(caption$ | async)">
            <div fitText class="value" [maxFontSize]="150">
                {{ singleValue }}
            </div>
        </div>
        @if (caption$ | async; as caption) {
            <div class="caption-wraper">
                <div fitText class="caption" [maxFontSize]="105">{{ caption }}</div>
            </div>
        }
    </div>
} @else {
    <loading-and-error class="no-data" [hasNoData]="true" />
}
